/**
 * Onboarding wizard store.
 *
 * No auth-attaching dispatch wrapper here: every command in this domain is flow
 * bookkeeping, and the privileged work it triggers (connecting a channel,
 * starting an import) goes out as commands on the domains that own them, which
 * carry their own capability gates.
 */

import { createStore } from '@commandDrivenStateEngine/core/createStore';
import { ClientLibraryType } from '@bett3r-dev/teselly-client-library';
import { initialState } from './state';
import { handlers } from './handlers';
import { invariants } from './invariants';
import { createConnectionWatchPolicy } from './policies/connectionWatchPolicy';

const store = createStore({
  name: 'onboarding-wizard',
  initialState,
  handlers,
  invariants
});

export const {
  useSelector: useOnboardingWizardSelector,
  useErrors: useOnboardingWizardErrors,
  useDispatch: useOnboardingWizardDispatch,
  usePolicies: useOnboardingWizardPolicies,
  getState: getOnboardingWizardState,
  dispatch: dispatchOnboardingWizardCommand
} = store;

export const createOnboardingWizardPolicies = ( backend: ClientLibraryType ) => [
  createConnectionWatchPolicy( backend )
];

export { selectors as onboardingWizardSelectors } from './state';
